<template>
  <Layout>
    <div class="router-view">
      <BusinessComboBox class="mx-auto max-w-md px-8 pb-8" />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/Main'
import BusinessComboBox from '@/components/customer/BusinessComboBox'

export default {
  components: {
    Layout,
    BusinessComboBox,
  },
}
</script>
